import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=8d4cab5a&scoped=true"
import script from "./ModalWrapper.js?vue&type=script&lang=js&external"
export * from "./ModalWrapper.js?vue&type=script&lang=js&external"
import style0 from "./ModalWrapper.scss?vue&type=style&index=0&id=8d4cab5a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4cab5a",
  null
  
)

export default component.exports